"use strict";

var backsidePrinting = require('./backsidePrinting');

var orientation = require('./orientation');

var bleed = require('./bleed');

var customerName = require('./customerName');

var designName = require('./designName');

var linerType = require('./linerType');

var customProductType = require('./customProductType');

var pdf = require('./pdf');

var productTypeForPrinting = require('./productTypeForPrinting');

var placeCardsProductType = require('./placeCardsProductType');

var size = require('./size');

var length = require('./length');

var thickWrapperType = require('./thickWrapperType');

var updatedFiles = require('./updatedFiles');

var variableData = require('./variableData');

var version = require('./version');

var wrapperColor = require('./wrapperColor');

var thickWrapperColor = require('./thickWrapperColor');

var employeeName = require('./employeeName');

var paperType = require('./paperType');

var date = require('./date');

var customSize = require('./customSize');

var thankYouMessage = require('./thankYouMessage');

module.exports = {
  backsidePrinting: backsidePrinting,
  orientation: orientation,
  bleed: bleed,
  customerName: customerName,
  designName: designName,
  linerType: linerType,
  customProductType: customProductType,
  pdf: pdf,
  productTypeForPrinting: productTypeForPrinting,
  placeCardsProductType: placeCardsProductType,
  size: size,
  length: length,
  thickWrapperType: thickWrapperType,
  updatedFiles: updatedFiles,
  variableData: variableData,
  version: version,
  wrapperColor: wrapperColor,
  thickWrapperColor: thickWrapperColor,
  employeeName: employeeName,
  paperType: paperType,
  date: date,
  customSize: customSize,
  thankYouMessage: thankYouMessage
};